
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formate/[slug]",
      function () {
        return require("private-next-pages/formate/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/formate/[slug]"])
      });
    }
  